import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "turn"
  }, [_c('m-head'), _c('div', {
    staticClass: "turn-body page-body"
  }, [_c('div', {
    staticClass: "turn-main page-main",
    style: {
      background: `url(${require(`@images/lucky/lucky-page-bg.jpg`)}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "turn-container"
  }, [_c('div', {
    staticClass: "turn-bg",
    style: {
      background: `url(${require(`@images/lucky/lucky-bg.png`)}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "turn-con",
    attrs: {
      "id": "luckyTableMain"
    }
  }, [_vm.prizeList ? [_c('lucky-wheel', {
    ref: "vueLuckywheel",
    attrs: {
      "prize-index": _vm.prizeIndex
    },
    on: {
      "game-over": _vm.onResult
    }
  }, _vm._l(_vm.prizeList, function (prize, index) {
    return _c('lucky-wheel-item', {
      key: index
    }, [prize ? [_c('transition', {
      attrs: {
        "appear": "",
        "name": "prizeScaleAnim",
        "tag": "div"
      }
    }, [_c('div', {
      staticClass: "luckyTable-item",
      class: index == _vm.prizeIndex && _vm.isResultAnim && 'result'
    }, [_c('div', {
      staticClass: "luckyTable__bg",
      style: {
        background: `url(${require(`@images/lucky/lucky-8-item-${index % 2 ? 1 : 2}.png`)}) center top/100% auto no-repeat`
      }
    }), _c('div', {
      staticClass: "luckyTable-item-main"
    }, [_c('div', {
      staticClass: "luckyTable__icon",
      style: {
        backgroundImage: `url(${require(`@images/${prize.type == 'TICKET' ? 'PASS' : prize.type}.png`)})`
      }
    }), _c('div', {
      staticClass: "luckyTable__num"
    }, [_vm._v(_vm._s(_vm._f("fmt_pre")(prize.value)))])])])])] : _vm._e()], 2);
  }), 1)] : _vm._e()], 2), _c('transition', {
    attrs: {
      "name": "multipleInfo"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMultipleInfoShow,
      expression: "isMultipleInfoShow"
    }],
    staticClass: "machine-multiple__info"
  }, [_vm._v("All rewards x " + _vm._s(this.selectCountOptions))])]), _c('div', {
    staticClass: "turn-btns"
  }, [_vm.luckyInfo && JSON.stringify(_vm.luckyInfo) != '{}' ? [!_vm.isPageLoading ? _c('div', {
    ref: "machineMultipleRef",
    staticClass: "turn-multiple",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.selectMultiple.apply(null, arguments);
      }
    }
  }, [_c('span', [_vm._v("x " + _vm._s(_vm.fmt_pre(_vm.selectCountOptions)))])]) : _vm._e(), !_vm.isPageLoading ? _c('div', {
    staticClass: "btn-turn",
    class: _vm.isBtnLoading && 'disable',
    style: {
      background: `url(${require(`@images/lucky/lucky-btn1-bg.png`)}) center top/100% auto no-repeat`
    },
    on: {
      "click": _vm.onStart
    }
  }, [_c('div', {
    staticClass: "btn-turn-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/lucky/lucky-btn1-text.png'),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "btn-turn-cost"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-stock.png'),
      "alt": ""
    }
  }), _c('span', {
    class: _vm.userInfo.stock < _vm.deductionSpins && 'err'
  }, [_vm._v(_vm._s(_vm.luckyInfo.price_stock))])])])]) : _vm._e()] : _vm.luckyInfo && JSON.stringify(_vm.luckyInfo) == '{}' ? [_c('div', {
    staticClass: "btn-turn"
  }, [_c('div', {
    staticClass: "btn-turn-main under"
  }, [_c('div', {
    staticClass: "under-main",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm._v(" Under maintenance "), _c('div', {
    staticClass: "icon-refresh"
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)])])])] : [_vm._m(0)]], 2)], 1), _c('div', {
    staticClass: "turn-balance"
  }, [_c('div', {
    staticClass: "turn-balance-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-stock.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.stock)) + " "), _c('div', {
    staticClass: "stock-number",
    attrs: {
      "id": "stockNumberDiv"
    }
  })])]), _c('div', {
    staticClass: "btn-add",
    on: {
      "click": () => _vm.$router.push('/upgrade')
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-add"
    }
  })], 1)])])]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "show": _vm.popStockEnoughShow,
      "content": "html",
      "title": " ",
      "isBtnCancel": false,
      "confirmText": "Get"
    },
    on: {
      "update:show": function ($event) {
        _vm.popStockEnoughShow = $event;
      },
      "confirm": () => _vm.$router.push('/upgrade')
    }
  }, [_c('div', {
    staticClass: "pop-enough"
  }, [_c('div', {
    staticClass: "pop-enough__icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon-stock.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-enough__label"
  }, [_vm._v("Insufficient balance")]), _c('div', {
    staticClass: "pop-enough__balance"
  }, [_c('div', {
    staticClass: "pop-enough__balance_m"
  }, [_vm._v("Balance:  "), _c('img', {
    attrs: {
      "src": require(`@images/icon-stock.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.stock)))])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-turn"
  }, [_c('div', {
    staticClass: "btn-turn-main loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])]);
}];
export { render, staticRenderFns };